<template>
  <div class="personality-loyal-content" id="plataforma-de-marca-personalidade-somos-leais" data-search-anchor>
    <div class="personality-loyal-overlay-title-image">
      <h1 class="personality-loyal-image-technology-title">
        {{ PersonalityLoyalToValuesTitle }}
      </h1>
      <p class="personality-loyal-image-technology-text">
        {{ PersonalityLoyalToValuesTitle2}}
      </p>
    </div>

    <div
      class="personality-loyal-banner-image"
      :style="{ backgroundImage: `url(${PersonalityLoyalToValuesImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PersonalityPageMixin from '@/mixins/personality-page-mixin'
import {PersonalityPageStore } from '@/store/brand-plataform-page/personality-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PersonalityLoyalToValuesSection extends Mixins(PersonalityPageMixin) {
  personalityPageStore: PageStoreContract = getModule(PersonalityPageStore, this.$store)

  get PersonalityLoyalToValuesTitle(): string {
    return this.getElementText(5, 0)
  }

  get PersonalityLoyalToValuesImageSrc(): string {
    return this.getElementMedia(5, 0)
  }

  get PersonalityLoyalToValuesTitle2(): string {
    return this.getElementText(5, 1)
  }

  get PersonalityLoyalToValuesTitle3(): string {
    return this.getElementText(5, 2)
  }

  async getPersonalityPageStore(): Promise<void> {
    await this.personalityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.personalityPageStore.isLoading) {
      await this.getPersonalityPageStore()
    }
  }
}
</script>

<style lang="scss">
.personality-loyal-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;
}

.personality-loyal-banner-image {
  margin-top: 64px;
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.personality-loyal-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;
}

.personality-loyal-image-technology-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
  margin-bottom: 2rem;
  margin-top: 4rem;
}

.personality-loyal-image-technology-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}
</style>
